import React from 'react';
import uuid from 'uuid';
import ModalProvider from './ModalProvider';
import ModalContent from './ModalContent';
export default class Modal extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            hiding: false,
            visible: this.props.visible,
        };
        this.uniqId = uuid.v4();
        this.handleFinishedHiding = () => {
            this.setState({ hiding: false });
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.visible && !props.visible) {
            return { ...state, visible: props.visible, hiding: true };
        }
        return null;
    }
    renderModal() {
        const { title, children, size, className, onClose, hasCancel, renderFooter, isOverlayClickHidesModal, isCloseCrossVisible, } = this.props;
        const { hiding } = this.state;
        return (<ModalContent className={className} hiding={hiding} isCloseCrossVisible={isCloseCrossVisible} isOverlayClickHidesModal={isOverlayClickHidesModal} renderFooter={renderFooter} size={size} title={title} onClose={onClose} hasCancel={hasCancel} onFinishedHiding={this.handleFinishedHiding}>
        {children}
      </ModalContent>);
    }
    render() {
        const { visible } = this.props;
        const { hiding } = this.state;
        const { showModal } = this.context;
        if (visible || hiding) {
            return showModal(this.renderModal(), this.uniqId);
        }
        return null;
    }
}
Modal.contextTypes = {
    showModal: Function,
};
Modal.defaultProps = {
    title: null,
    size: null,
    renderFooter: null,
    className: '',
    onClose: null,
    isOverlayClickHidesModal: false,
    hasCancel: false,
    isCloseCrossVisible: true,
};
Modal.Provider = ModalProvider;
